import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledShakeComponent } from "./shake-component.scss";
class ShakeComponent extends PureComponent {
    render() {
        const { children, isActive } = this.props;
        return /*#__PURE__*/ _jsx(StyledShakeComponent, {
            className: `shake ${isActive ? "active" : "stop"}`,
            children: children
        });
    }
}
export { ShakeComponent as default };
ShakeComponent.defaultProps = {
    isActive: false
};
